import { TextFieldHelper } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserTextsVO } from "./common/TeaserTextsVO";
import { TeaserVO } from "./common/TeaserVO";

import MovieClip = createjs.MovieClip;

export class RabbitCamTeaser extends AbstractTeaser {
    private _txtTitle: TextField;
    private _btnOk: MovieClip;
    private _tf_playerState: TextField;
    private _tf_rabbitCam: TextField;

    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super(featureId, teaserMc, teaserVO);
    }

    protected buildHook(): void {
        this._txtTitle = this._teaserMc.txt_title;
        this._btnOk = this._teaserMc.btn_ok;

        this._teaserMc.content.mouseChildren = false;
        this._tf_rabbitCam = this._teaserMc.content.txt_rabbitCam;
        this._tf_playerState = this._teaserMc.content.txt_playerState;
    }

    public fillTexts(vo: TeaserTextsVO): void {
        super.fillTexts(vo);

        this._txtTitle.text = vo.titleStr;

        TextFieldHelper.changeTextFromatSizeByTextWidth(13, this._tf_playerState, Poker2Model.languageData.getTextById("table_playerStatus_waiting"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this._tf_rabbitCam, Poker2Model.languageData.getTextById("table_btn_rabbitcam"));
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        var textVO: TeaserTextsVO = (vo == null) ? this._teaserVO.teaserTextsVO : vo;

        this._btnOk.label = textVO.btnOkLabel;
    }
}
classImplementsInterfaces(RabbitCamTeaser, "Container");
